const UPSELL_PRODUCTS = [
  'elena-conjunto-de-saten-midi-con-sueter-incluido',
  'livia-vestido-largo-con-cuello-halter-y-estampado-floral',
  'armellose-leinen-latzhose',
  'mono-con-escote-cruzado-elegancia-en-cada-paso',
  'elena-pasos-sin-dolor-mocasines-ortopedicos-susie-para-el-cuidado-de-tus-pies',
  'annmarie-bequemes-midi-kleid',
  'elisa-zapatos-de-tacon-elegantes-confort-absoluto-para-lucir-con-estilo',
  'margaret-conjunto-triple-chic',
  'aurora-mocasines-de-ensueno',
  'aurora-vestido-con-cuello-americano-y-estampado-de-acuarela',
  'bolso-de-tela-con-decoracion-minimalista',
  'bolso-grande-de-hombro-tipo-hobo-de-paja-para-mujer',
  'flavia-elegante-vestido-largo-morado-con-escote-en-gota-y-borde-de-encaje-de-chifon',
  'marineblau-chiffon-set-ruschen',
  'weisses-leinen-faltenkleid-maxi',
  'bolso-mini-con-asas-de-cuerda',
  'paulina-conjunto-de-tres-piezas-exclusivo',
  'carol-conjunto-de-tres-piezas-chic'
];

let cachedUpsellProducts = null;

async function fetchProduct(handle) {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) return null;
  return res.json();
}

async function fetchAllUpsells() {
  if (cachedUpsellProducts) return cachedUpsellProducts;
  const fetched = await Promise.all(UPSELL_PRODUCTS.map(fetchProduct));
  cachedUpsellProducts = fetched.filter(Boolean);
  return cachedUpsellProducts;
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}

function buildCard(product) {
  const image = product.featured_image || '';
  const title = product.title;
  const variants = product.variants;
  const hasDiscount = variants[0].compare_at_price && variants[0].compare_at_price > variants[0].price;

  const variantOptions = variants.map(v => `<option value="${v.id}">${v.title}</option>`).join('');

  const selectHtml = variants.length > 1
    ? `<select class="cart-upsell-variant-select" data-variant-select="${product.id}">${variantOptions}</select>`
    : `<input type="hidden" data-variant-select="${product.id}" value="${variants[0].id}">`;

  const priceHtml = hasDiscount
    ? `<span class="cart-upsell-price-original">${formatMoney(variants[0].compare_at_price)}</span>
       <span class="cart-upsell-price-sale">${formatMoney(variants[0].price)}</span>`
    : `<span class="cart-upsell-price-sale">${formatMoney(variants[0].price)}</span>`;

  return `
    <div class="cart-upsell-card">
      <img src="${image}" alt="${title}">
      <div class="cart-upsell-card-info">
        <div class="cart-upsell-card-title">${title}</div>
        <div>${priceHtml}</div>
        ${selectHtml}
        <br>
        <button class="cart-upsell-add-btn" type="button" data-product-id="${product.id}">Añadir</button>
      </div>
    </div>
  `;
}

async function addToCart(productId, scope, btn) {
  const select = scope.querySelector(`[data-variant-select="${productId}"]`);
  if (!select) return;
  
  const originalText = btn.innerText;
  btn.innerText = 'Añadiendo...';
  btn.style.opacity = '0.7';
  btn.style.pointerEvents = 'none';

  try {
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    
    const res = await fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: select.value, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' })
    });
    const parsedState = await res.json();

    // Actualizar usando la función nativa de Shopify Dawn si existe
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(parsedState);
    } else {
      // Reemplazo silencioso manual (Fallback)
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = parsedState.sections['cart-drawer'];
      
      const targetItems = document.getElementById('CartDrawer-CartItems');
      const sourceItems = tempDiv.querySelector('#CartDrawer-CartItems');
      if (targetItems && sourceItems) targetItems.innerHTML = sourceItems.innerHTML;

      const targetFooter = document.querySelector('.cart-drawer__footer');
      const sourceFooter = tempDiv.querySelector('.cart-drawer__footer');
      if (targetFooter && sourceFooter) targetFooter.innerHTML = sourceFooter.innerHTML;
      
      const targetBubble = document.getElementById('cart-icon-bubble');
      const sourceBubble = tempDiv.querySelector('#cart-icon-bubble');
      if (targetBubble && sourceBubble) targetBubble.innerHTML = sourceBubble.innerHTML;
    }
  } catch (error) {
    console.error('Error AJAX:', error);
  } finally {
    btn.innerText = '¡Añadido! ✓';
    setTimeout(() => { btn.innerText = originalText; btn.style.opacity = '1'; btn.style.pointerEvents = 'auto'; }, 2000);
  }
}

// 1. INICIAR UPSELL
async function initUpsellSection(section) {
  const track = section.querySelector('.cart-upsell-track');
  if (!track) return;

  const products = await fetchAllUpsells();
  if (products.length === 0) { section.style.display = 'none'; return; }

  track.innerHTML = products.map(buildCard).join('');
  let currentIndex = 0;
  function updateSlider() { track.style.transform = `translateX(-${currentIndex * 100}%)`; }

  const prevBtn = section.querySelector('.cart-upsell-prev');
  const nextBtn = section.querySelector('.cart-upsell-next');

  if (prevBtn) prevBtn.onclick = () => { currentIndex = (currentIndex - 1 + products.length) % products.length; updateSlider(); };
  if (nextBtn) nextBtn.onclick = () => { currentIndex = (currentIndex + 1) % products.length; updateSlider(); };

  track.onclick = (e) => {
    const btn = e.target.closest('.cart-upsell-add-btn');
    if (btn) addToCart(btn.getAttribute('data-product-id'), section, btn);
  };
}

// 2. INICIAR CONTADOR (Sin reiniciarse jamás)
let timerInterval = null;
let timeLeft = 179; 
function initCartTimer() {
  const el = document.getElementById('cart-drawer-countdown');
  if (!el || el.hasAttribute('data-timer-running')) return;
  el.setAttribute('data-timer-running', 'true');

  if (timerInterval) clearInterval(timerInterval);
  timerInterval = setInterval(() => {
    timeLeft--;
    if (timeLeft <= 0) timeLeft = 179;
    const currentEl = document.getElementById('cart-drawer-countdown');
    if (!currentEl) { clearInterval(timerInterval); timerInterval = null; return; }
    const m = Math.floor(timeLeft / 60);
    const s = timeLeft % 60;
    currentEl.textContent = m + ':' + (s < 10 ? '0' + s : s);
  }, 1000);
}

// 3. INICIAR BARRA DE DESCUENTO
function initCartProgress() {
  const box = document.getElementById('CartDrawerDiscountProgress');
  if (!box) return;

  const t1 = parseInt(box.getAttribute('data-tier1')) || 2;
  const t2 = parseInt(box.getAttribute('data-tier2')) || 3;
  const t3 = parseInt(box.getAttribute('data-tier3')) || 4;
  const p1 = box.getAttribute('data-pct1') || '10';
  const p2 = box.getAttribute('data-pct2') || '15';
  const p3 = box.getAttribute('data-pct3') || '20';

  let count = 0;
  document.querySelectorAll('#CartDrawer-CartItems .quantity__input').forEach(input => {
    count += parseInt(input.value, 10) || 0;
  });

  let progress = 0; let message = '';
  if (count >= t3) { progress = 100; message = `<strong>¡Enhorabuena! Has conseguido el ${p3}% de descuento.</strong>`; } 
  else if (count >= t2) { progress = 50; let need = t3 - count; message = `Agrega ${need} artículo${need !== 1 ? 's' : ''} más para un <strong>${p3}%</strong> extra.`; } 
  else if (count >= t1) { progress = 0; let need = t2 - count; message = `Agrega ${need} artículo${need !== 1 ? 's' : ''} más para un <strong>${p2}%</strong> extra.`; } 
  else { progress = 0; let need = t1 - count; message = `Agrega ${need} artículo${need !== 1 ? 's' : ''} más para un <strong>${p1}%</strong> extra.`; }

  const fill = box.querySelector('.cart-discount-progress__fill');
  if (fill) fill.style.width = progress + '%';
  const msg = box.querySelector('.cart-discount-progress__message');
  if (msg) msg.innerHTML = message;

  const steps = box.querySelectorAll('.cart-discount-progress__step');
  if (steps[0]) steps[0].classList.toggle('is-active', count >= t1);
  if (steps[1]) steps[1].classList.toggle('is-active', count >= t2);
  if (steps[2]) steps[2].classList.toggle('is-active', count >= t3);
}

// 4. EL VIGILANTE (Reactiva todo sin importar qué haga Shopify)
function onCartUpdate() {
  document.querySelectorAll('.cart-upsell-section').forEach(sec => {
    if (!sec.hasAttribute('data-upsell-initialized')) {
      sec.setAttribute('data-upsell-initialized', 'true');
      initUpsellSection(sec);
    }
  });
  initCartTimer();
  initCartProgress();
}

const cartObserver = new MutationObserver(() => {
  clearTimeout(window.cartDebounce);
  window.cartDebounce = setTimeout(onCartUpdate, 150);
});

document.addEventListener('DOMContentLoaded', () => {
  onCartUpdate();
  cartObserver.observe(document.body, { childList: true, subtree: true });
});